function customizedColorSwatches () {
    const colorsGroup = document.querySelectorAll('.card-wrapper .colors-group-wrapper label.color-swatch');
	colorsGroup.forEach(group => {
		group.addEventListener('click', () => {
            const productHandle = group.getAttribute("data-handle");
			group.closest('.product-group-card-container').querySelectorAll('.card-wrapper').forEach(wrapper => {
				wrapper.classList.remove('selected');
                if (wrapper.getAttribute("data-product") == productHandle) {
                    wrapper.classList.add('selected');
                }
			})
		})
	})
}

function customizedColorSwatchesForUpsell () {
	const colorsGroup = document.querySelectorAll('.product__upsell__product .colors-group-wrapper label.color-swatch');
	colorsGroup.forEach(group => {
		group.addEventListener('click', () => {
            const productHandle = group.getAttribute("data-handle");
			group.closest('.upsell-product-group-container').querySelectorAll('.product__upsell__product').forEach(wrapper => {
				wrapper.classList.remove('selected');
                if (wrapper.getAttribute("data-product") == productHandle) {
                    wrapper.classList.add('selected');
                }
			})
		})
	})
}

customizedColorSwatches();
customizedColorSwatchesForUpsell();